import { render } from "./CoverPage.vue?vue&type=template&id=d9c767be&scoped=true"
import script from "./CoverPage.vue?vue&type=script&lang=js"
export * from "./CoverPage.vue?vue&type=script&lang=js"

import "./CoverPage.vue?vue&type=style&index=0&id=d9c767be&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9c767be"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QFooter from 'quasar/src/components/footer/QFooter.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QFooter,QToolbar,QSpace,QPageContainer,QPage,QSeparator,QImg});
